import { Getter } from "vuex";
import { IState, IEvent } from './state';

const dates: Getter<IState, IState> = (state) => {
	const dates:any = {};
	if(!state.events || state.events.length === 0) {
		return dates;
	}
	let date:string = '';
	state.events.forEach((event) => {
		if(event.date !== date) {
			date = event.date;
		}
		if(dates[date] && Array.isArray(dates[date])) {
			dates[date].push(event)
		} else {
			dates[date] = [event];
		}  
	});
	Object.keys(dates).forEach(key => {
		dates[key] = dates[key].sort((a:IEvent, b:IEvent) => {
			return a.time - b.time;
		})
	})
	return dates;
}

export default {
	dates
}
